import * as React from "react";
export var SnackbarContext = React.createContext({
    spawn: function(_message) {
        var _level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "info";
        return undefined;
    }
});
